import { InjectionToken } from '@angular/core';
import { SharedEnvironment } from './shared-environment.model';

export const SHARED_ENVIRONMENT = new InjectionToken<SharedEnvironment>('SHARED_ENVIRONMENT');